import {Avatar, Box, Grid, GridProps, Heading, HStack, Spacer} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Logo} from 'components/shared';
import {RightBlock} from 'components/shared/right-block-header';
import {useDesktop} from 'hooks';
import {FC, PropsWithChildren, ReactElement} from 'react';
import ImageUI from 'ui/ImageUI';

import {HeaderWrapper} from '../header-wrapper';

export * from './components';

interface Props {
  title?: string;
  showLogo?: boolean;
  onBack?: () => void;
  gridProps?: GridProps;
  aside: ReactElement;
}

export const AsideLayout: FC<PropsWithChildren<Props>> = ({children, onBack, showLogo, gridProps, title, aside}) => {
  const isDesktop = useDesktop();
  return (
    <>
      <HStack
        // maximumScale="1"
        position="fixed"
        w="100%"
        top={0}
        zIndex={99}
      >
        <HeaderWrapper>
          <HStack spacing={['15px', '30px']}>
            {showLogo ? (
              <Logo isDesktop={isDesktop} />
            ) : (
              <Avatar
                onClick={onBack}
                w={['40px', '50px']}
                h={['40px', '50px']}
                cursor="pointer"
                bg={colors.pink}
                color="white"
                icon={<ImageUI src="/icons/arrow-left.svg" alt="Arrow left icon" />}
              />
            )}
            <Heading fontSize={['18px', '24px']} fontWeight="700">
              {title}
            </Heading>
          </HStack>
          <Spacer />
          <RightBlock isDesktop accordionMobileSize={isDesktop ? '100%' : undefined} />
        </HeaderWrapper>
      </HStack>
      <Box as="main" maxW="1440px" mx="auto" mt={['60px', '80px']} pb="0px">
        <Grid templateColumns={['1fr', '1fr 420px']} gap="30px" p={['20px 15px', '30px 60px']} {...gridProps}>
          <Box>{children}</Box>
          <Box as="aside" position="sticky" alignSelf="start" top="100px">
            {aside}
          </Box>
        </Grid>
      </Box>
    </>
  );
};
